import { render, staticRenderFns } from "./MainMenuItem.vue?vue&type=template&id=2063c9e8&scoped=true"
import script from "./MainMenuItem.vue?vue&type=script&lang=js"
export * from "./MainMenuItem.vue?vue&type=script&lang=js"
import style0 from "./MainMenuItem.vue?vue&type=style&index=0&id=2063c9e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2063c9e8",
  null
  
)

export default component.exports